"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M3 0C2.665 0 .331.008 0 .023v1.002C.331 1.008 2.665 1 3 1c11.046 0 20 8.954 20 20 0 .335-.008 2.669-.025 3h1.002c.015-.331.023-2.665.023-3C24 9.402 14.598 0 3 0z"
  }), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M18 22c0 .336-.011 1.67-.033 2h-1.002c.023-.33.035-1.664.035-2 0-7.732-6.268-14-14-14-.336 0-2.67.012-3 .035V7.033C.33 7.011 2.664 7 3 7c8.284 0 15 6.716 15 15z"
  }), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M12 22c0 .338-.019 1.672-.055 2h-1.007c.153-1.21.026-3.44-.369-4.593a8 8 0 00-4.976-4.976C4.44 14.036 1.21 13.909 0 14.062v-1.007c1.258-.14 4.533-.014 5.739.371A9 9 0 0112 22z"
  }), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 21.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
    clipRule: "evenodd"
  }));
}

var _default = 'src/asset/icon/community.icon.svg';
exports.default = _default;
//# sourceMappingURL=community.icon.js.map